import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import React, { useEffect } from "react";
import * as uuid from "uuid";
import { ChargeableTripsRow, DriversRow } from "../../api";
import { MonthDayPicker } from "../../components/datepickers/MonthDayPicker";
import { DriverPulldown } from "../../components/driverPulldown";
import { OfficePullDown } from "../../components/officePullDown";
import {
    LoadingTableElement,
    NullTableElement,
} from "../../components/table/nullTable";
import {
    SortableTable,
    newDisplayCond,
} from "../../components/table/sortableTable";
import * as service from "../../services/usage_based_trips/select";
import { commonSlice, commonState, store } from "../../store";
import { Row, headCells } from "./columns_billedTripsDetails";
import { State } from "./store";

interface Props {
    state: State;
    common: commonState;
}

export const BilledTripsSearchBar: React.FC<Props> = (props: Props) => {
    const click_search = () => {
        service.selectUsageTrip();
    };

    const selectOffice = (officeId: number): void => {
        store.dispatch(commonSlice.actions.updateSelectedOffice(officeId));
    };

    const selectDriver = (driver: DriversRow) => {
        store.dispatch(commonSlice.actions.updateSelectedDriver(driver));
    };

    const clearDriver = () => {
        store.dispatch(commonSlice.actions.updateSelectedDriver(null));
    };

    return (
        <Box sx={{ display: "flex", alignItems: "end" }}>
            <Box sx={{ display: "flex", p: 2, alignItems: "end" }}>
                <OfficePullDown
                    selectedOfficeId={props.common.selectedOfficeId}
                    onChange={selectOffice}
                    useAllOfficeIds={true}
                />
            </Box>
            <Box sx={{ display: "flex", p: 2, alignItems: "end" }}>
                <DriverPulldown
                    selectedDriver={props.common.selectedDriver}
                    driverCompleteData={props.common.driverNames}
                    onChange={selectDriver}
                    onClear={clearDriver}
                    initWithNull={false}
                ></DriverPulldown>
                <Box sx={{ display: "flex", pl: 3, alignItems: "end" }}>
                    <Box sx={{ p: 2 }}>乗務日</Box>
                    <MonthDayPicker
                        initialDate={props.state.startDate}
                        onChangeMethod={(value) => {
                            service.set_start_date(value);
                        }}
                    />
                </Box>
                <Box sx={{ p: 1 }}>
                    <Button
                        variant="contained"
                        onClick={async (ev) => {
                            service.set_start_date("");
                        }}
                        color="info"
                        size="small"
                    >
                        クリア
                    </Button>
                </Box>
                <Box sx={{ fontSize: "30px", pl: 2, pr: 2 }}>~</Box>
                <Box>
                    <MonthDayPicker
                        initialDate={props.state.endDate}
                        onChangeMethod={(value) => {
                            service.set_end_date(value);
                        }}
                    />
                </Box>
                <Box sx={{ p: 1 }}>
                    <Button
                        variant="contained"
                        onClick={async (ev) => {
                            service.set_end_date("");
                        }}
                        color="info"
                        size="small"
                    >
                        クリア
                    </Button>
                </Box>
                <Box sx={{ p: 1, pl: 2 }}>
                    <Button
                        variant="contained"
                        onClick={click_search}
                        color="primary"
                        size="small"
                    >
                        検索
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export const BilledTripsDetailsContainer: React.FC<Props> = (props: Props) => {
    return (
        <Box>
            <BilledTripsSearchBar {...props} />
            <TripsDetailsTable {...props} />
        </Box>
    );
};

const convertChargeableToDataTableFormat = (
    recs: ChargeableTripsRow[]
): Row[] => {
    const _data = recs.map((rec: ChargeableTripsRow) => {
        return {
            deliveredDurationAfterNaviOff: rec.deliveredDurationAfterNaviOff,
            useNaviAtDelivered: rec.useNaviAtDelivered,
            rideType: rec.rideType,
            deliverStartedAt: rec.deliverStartedAt,
            unladenTripStartedAt: rec.unladenTripStartedAt,
            driverName: rec.driverName,
            driverCode: rec.driverCode,
            shiftDate: rec.shiftDate,
            naviShape: rec.naviShape,
            officeName: rec.officeName,
            startLocation: rec.startLocation,
            deliveredLocation: rec.deliveredLocation,
            unladenShape: rec.unladenShape,
            deliverStartLoc: rec.deliverStartLoc,
            unladenStartLoc: rec.unladenStartLoc,
            trip: rec,
            tripSessionId: rec.tripSessionId,
            loginSessionId: rec.loginSessionId,
            boardingType: rec.boardingType,
            row_id: uuid.v4(),
        } as Row;
    });
    return _data;
};

export const TripsDetailsTable: React.FC<Props> = (props: Props) => {
    let _data: Row[] = [];
    if (props.state.chargeableTrips && props.state.chargeableTrips.trips) {
        _data = convertChargeableToDataTableFormat(
            props.state.chargeableTrips.trips
        );
    }
    useEffect(() => {
        if (!props.state.chargeableTrips) {
            service.selectUsageTrip();
        }
    }, []);

    console.log("TripsTable Data...", props.state);

    if (
        !props.state.chargeableTrips ||
        !props.state.chargeableTrips.trips
        // props.state.chargeableTrips.trips.length == 0
    ) {
        return <LoadingTableElement />;
    }

    if (props.state.chargeableTrips.trips.length == 0) {
        return <NullTableElement />;
    }

    return (
        <SortableTable
            tableHeaders={headCells}
            tableData={_data}
            tableProps={props}
            displayCond={newDisplayCond("driver_name", "asc", 0, 20)}
            rowIdField={"row_id"}
            onRowClickMethod={() => {}}
            slimRows={true}
        />
    );
};
